export default "__VITE_ASSET__CDWaqux9__"